import ElementController from "./ElementController";

export default class SceneController extends ElementController {
}
